import { AfterViewInit, ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { isNullOrUndefined } from '@sla-ng/core';
import { ICostUnit } from '../../../../models/cost-unit.model';
import { Observable } from 'rxjs';
import { ICostUnitState } from '../../../../services/facades/master-data/cost-unit-state.model';
import { CostUnitFacade } from '../../../../services/facades/master-data/cost-unit.facade';

@Component({
    selector: 'app-cost-type-dialog',
    templateUrl: './cost-unit-dialog.component.html',
    styleUrls: [ './cost-unit-dialog.component.scss' ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CostUnitDialogComponent implements OnInit, AfterViewInit {
    public costUnitState$: Observable<ICostUnitState>;
    public formGroup: FormGroup;
    public dialogFieldsValid: boolean = false;


    constructor(
        private myMatDialogRef: MatDialogRef<CostUnitDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ICostUnit,
        private myCostUnitFacade: CostUnitFacade,
    ) {
    }

    public ngOnInit(): void {
        this.costUnitState$ = this.myCostUnitFacade.subState();
    }

    public ngAfterViewInit(): void {
        this.formGroup.valueChanges.subscribe((costUnit: ICostUnit) => {
            this.validateDialogFields(costUnit);
        });
    }

    public async save(): Promise<void> {
        const data: ICostUnit = this.formGroup.value as ICostUnit;
        if (isNullOrUndefined(this.data.id)) {
            await this.myCostUnitFacade.addCostUnit(data);
        } else {
            data.id = this.data.id;
            await this.myCostUnitFacade.editCostUnit(data);
        }
        this.myMatDialogRef.close(true);

    }

    public close(): void {
        this.myMatDialogRef.close(false);
    }

    private validateDialogFields(costUnit: ICostUnit): void {
        // Validations to disable saving/editing
        if (!costUnit.name
            ||!costUnit.articleNr) {
            this.dialogFieldsValid = false;
        } else {
            this.dialogFieldsValid = true;
        }
    }

}
